import React from "react";

import DashboardLayout from "../layout/DashboardLayout";
import {
    Box, Alert, AlertIcon, Text, Spinner, VStack
} from '@chakra-ui/react';
import DashboardHeader from "../layout/component/DashboardHeader";
import { StatsCard } from "../layout/component/Assets";
import { BsBatteryCharging } from "react-icons/bs";
import { FiFile } from "react-icons/fi";
import useUserContext from "../components/UserContext";
import { AvatarMenu } from "../layout/component/AvatarMenu";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";


const Dashboard = () => {

    const [Loading, setisLoading] = React.useState(true);
    const { userDetails, loading, getUsersInfo, user } = useUserContext();
    const navigate = useNavigate();
    const handleLogout = async () => {
        sessionStorage.clear();
        localStorage.clear();
        Cookies.remove("userData");
        Cookies.remove("uid");
        Cookies.remove("isLoggedin");
        Cookies.remove("userLevel");
        Cookies.remove("token");
        navigate("/login");
    };
    return (
        <>

            <Box maxW="600px" mx="auto" mt={8} p={6}>
                <Alert status="info" borderRadius="md" mb={6}>
                    <AlertIcon />
                    <Box>
                        <Text fontWeight="bold" fontSize="lg">Welcome to the Staff Portal!</Text>
                        <Text mt={2}>
                            We're excited to have you onboard as part of our team.
                        </Text>
                    </Box>
                </Alert>

                <Box
                    border="1px solid"
                    borderColor="blue.200"
                    borderRadius="md"
                    p={6}
                    bg="blue.50"
                    textAlign="center"
                >
                    <VStack spacing={4}>
                        <Spinner size="xl" color="blue.500" thickness="4px" />
                        <Text fontSize="xl" fontWeight="bold" color="blue.800">
                            Staff Dashboard Update in Progress
                        </Text>
                        <Text>
                            Our team is currently working on updating the staff dashboard with
                            all the tools and features you'll need. We're enhancing your
                            experience to make your work more efficient and productive.
                        </Text>
                        <Text fontWeight="medium" color="blue.700">
                            Please hang tight while we complete the updates.
                        </Text>
                        <Text fontSize="sm" color="gray.600" fontStyle="italic">
                            We appreciate your patience and look forward to providing you with
                            an excellent staff experience very soon!
                        </Text>
                        <button className="bg-blue-500 px-5 py-2 hover:bg-blue-800" onClick={handleLogout}>Logout</button>
                    </VStack>
                </Box>

                <Box
                    mt={6}
                    p={4}
                    bg="gray.50"
                    borderRadius="md"
                    borderLeft="4px solid"
                    borderLeftColor="gray.400"
                >
                    <Text fontWeight="bold" mb={2}>What's Next?</Text>
                    <Text fontSize="sm">
                        • Complete staff onboarding process<br />
                        • Access to staff tools and resources<br />
                        • Team communication channels<br />
                        • Work schedule and task management<br />
                        • Performance tracking and reporting
                    </Text>
                </Box>
            </Box>
            {/* <DashboardLayout            > */}

            {/* <Stack
                    gap={6}
                    direction={{ base: 'column', md: 'column', sm: 'row' }}>
                    <SimpleGrid
                        columns={{ base: 1, md: 3 }}
                        spacing={{ base: 5, lg: 8 }}
                    >
                        <StatsCard
                            bgColor={'yellow.400'}
                            title={'Profile Strength'}
                            stat={40}
                            icon={<BsBatteryCharging size={'3em'} />}
                        />
                        <StatsCard
                            StatLink="/dashboard/view-all-uploaded-document"
                            bgColor={'green.400'}
                            title={'Uploaded Documnet'}
                            stat={80}
                            icon={<FiFile size={'3em'} />}
                        />
                        <StatsCard
                            StatLink="#"
                            bgColor={'red.400'}
                            title={'Expired Documnet'}
                            stat={80}
                            icon={''}
                        />
                    </SimpleGrid>
                </Stack> */}
            {/* 
            <Stack align={'center'} gap={6}>
                {/* <Heading>Timesheet Record</Heading> */}

            {/* <Button ml={4} ref={finalRef}>
          I'll receive focus on close
        </Button> */}

            {/* <TimeSheet />   </Stack> */}



            {/* </DashboardLayout> */}
        </>
    );
};

export default Dashboard;
